import { ApplicationQuestion, FieldType } from '@bybeam/platform-types';
import { makeEduConfig } from './baseConfig.js';

const CONFIG = makeEduConfig();

// update personal Info description
const personalInfoSection = CONFIG.sections.find(({ key }) => key === 'personalInfo');
personalInfoSection.overview.description = `In this section, you'll let us know what high school you attend, what month and year 
          you expect to graduate, and if you're responsible for taking care of any minors.`;

const personalInfoQuestionGroup = personalInfoSection.questionGroups.find(
  ({ key }) => key === 'personalInfo',
);

// Update copy for graduation date question
const graduationDateQuestion = personalInfoQuestionGroup.questions.find(
  ({ key }) => key === 'graduationDate',
);
graduationDateQuestion.copy.title = 'What month and year do you expect to finish high school?';

// Remove have you filed fafsa question
// Remove bank account question
personalInfoQuestionGroup.questions = personalInfoQuestionGroup.questions.filter(
  (question) => question.key !== 'filedFafsa',
);

const studentInfoQuestionGroup = personalInfoSection.questionGroups.find(
  ({ key }) => key === 'studentInfo',
);
const studentIdQuestion = studentInfoQuestionGroup.questions.find(({ key }) => key === 'studentId');
studentIdQuestion.copy.title = 'What is your Compton College Student ID?';

//  Add a new question for which high school you are attending
const newQuestions: { [key: string]: ApplicationQuestion } = {
  attendingHighSchool: {
    key: 'attendingHighSchool',
    copy: { title: 'What high school do you attend?' },
    fields: [
      {
        type: FieldType.Dropdown,
        validation: { required: true },
        key: 'attendingHighSchool',
        copy: 'High School you attend',
        options: [
          { label: 'Buena Vista High School', value: 'buenavistahighschool' },
          { label: 'Centennial High School', value: 'centennialhighschool' },
          { label: 'Compton Early College', value: 'comptonearlycollege' },
          { label: 'Compton High School', value: 'comptonhighschool' },
          { label: 'Dominguez High School', value: 'dominguezhighschool' },
          { label: 'Firebaugh High School', value: 'firebaughhighschool' },
          { label: 'Lynwood High School', value: 'lynwoodhighschool' },
          { label: 'Odessey High School', value: 'odesseyhighschool' },
          { label: 'Paramount High School', value: 'paramounthighschool' },
          { label: 'Paramount HS West Campus', value: 'paramounthswestschool' },
          { label: 'Pathway High School', value: 'pathwayhighschool' },
          { label: 'Vista High School', value: 'vistahighschool' },
        ],
      },
    ],
  },
};

studentInfoQuestionGroup.questions.push(newQuestions.attendingHighSchool);

// Remove documents section
CONFIG.sections = CONFIG.sections.filter(({ key }) => key !== 'documents');

export default CONFIG;
